import { Footer } from '~shared/ui/footer';
import { Screen, ScreenHeader } from '~shared/ui/screen';

import { Typography } from '@breezeventures/ui-kit/typography';

import StoreIcon from './icons/store.svg?react';

type StoresStartProps = {
  onBack: () => void;
  onClose: () => void;
  onSubmit: () => void;
};

export const StoresStart = ({
  onBack,
  onClose,
  onSubmit,
}: StoresStartProps) => {
  return (
    <Screen
      header={<ScreenHeader onBack={onBack} onClose={onClose} />}
      footer={<Footer submitButtonText="Add store" onSubmit={onSubmit} />}
    >
      <div className="my-auto flex flex-col items-center">
        <StoreIcon />

        <div className="mt-8 flex flex-col items-center gap-3 text-center">
          <Typography.Title size="s" className="px-2">
            Tell us about your stores,{' '}
            <span className="text-accent-1">boss!</span>
          </Typography.Title>
          <Typography.Text size="m" color="secondary">
            Enter&nbsp;each&nbsp;store&#39;s&nbsp;details one&nbsp;by&nbsp;one.
            List&nbsp;online&nbsp;and physical stores separately.
          </Typography.Text>
        </div>
      </div>
    </Screen>
  );
};
